import { CoreHomeView } from '../../../../core/views';

import template from './index.jst';
import off_season from './off_season.jst';
import './index.styl';
import { Secret } from '../../../NRL_Tipping/utils';

const IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON);

class HomeView extends CoreHomeView {
	get template() {
		return IS_PRE_SEASON ? off_season : template;
	}

	get className() {
		return "home-page home-page-tipping";
	}
}

export default HomeView;